// extracted by mini-css-extract-plugin
export default {"left":"lFIHE3Zuh+","right-name":"A02q+MGhUI","rightName":"A02q+MGhUI","right":"NpTNDXZtSP","secret-inspector":"M2tPlR2xCx","secretInspector":"M2tPlR2xCx","description":"uWSme6dBrB"};